import { Construction } from 'lucide-react';
import { EmptyState, PageHeader } from '@/components/ui';
import type { NavEntry } from '@/routes/registry';

/** Rendered for every registry entry whose `src/features/<screen>/index.tsx` does not exist yet. */
export function ComingSoon({ entry }: { entry: NavEntry }) {
  return (
    <div data-testid="placeholder-page">
      <PageHeader title={entry.label} />
      <div className="rounded-xl border border-dashed border-border bg-surface">
        <EmptyState
          icon={<Construction aria-hidden />}
          title="Coming in screen phase"
          description={`The ${entry.label} screen has not been built yet. Create src/features/${entry.screen}/index.tsx to replace this page.`}
        />
      </div>
    </div>
  );
}
